import React from "react";
import { Icon, Message } from "semantic-ui-react";

const DisponibilidadOperacionesPagosMessage = () => {
  return (
    <>
      <Message attached="bottom" size="small" color="blue">
        <Icon name="warning circle" />
        Esta operación sólo se puede realizar hasta las 8:00pm. Se considera
        cuota vencida, si el pago no se realizó hasta antes de la hora indicada.
      </Message>
    </>
  );
};

export default DisponibilidadOperacionesPagosMessage;
